import axios from 'axios';

export const GET_VEHICLE = "GET_VEHICLE";
export const EMPTY_VEHICLE = "EMPTY_VEHICLE";
export const RESET_VEHICLE = "RESET_VEHICLE";

export const GET_CATEGORY = "GET_CATEGORY";
export const EMPTY_CATEGORY = "EMPTY_CATEGORY";

export const TOGGLE_BOX_LOADING = "TOGGLE_BOX_LOADING";

export const ADD_BOX_ERROR = "ADD_BOX_ERROR";

export const REDIRECT = "REDIRECT";

export function searchLicencePlate(licencePlate) {
    return function (dispatch) {
        //on va verifier si le format de la plaque est bon
        let search=licencePlate.split("-").join("");
        search=search.split(" ").join("");
        if (search.length <= 7 && /^[A-Z]{1,2}[0-9]{1,3}[A-Z]{1,2}$/.test(search) ){
            console.log('nouvelle plaque')
        }else if (search.length <= 9 && /^[0-9]{1,4}[A-Z]{1,4}[0-9]{1,2}[A-B]{0,1}$/.test( search)){
            console.log('ancienne plaque')
        }else{
            dispatch(addBoxError('licencePlate','Le format de la plaque d\'immatriculation n\'est pas correct.'));
            $('.licence_plate_box').find('input').focus();
            //$('.licence_plate_box').find('input').addClass('blink');
            return;
        }
        dispatch(toggleBoxLoading('licencePlate'));
        return axios('/partauto/api/licence_plate?licence_plate=' + licencePlate)
            .then(function (response) {
                dispatch(setVehicle({...response.data, licencePlate}));
                // sendVehicleCookie({...response.data, licencePlate});
                $('.slider-testimonial').fadeOut();
                $('.slider2').fadeOut();

                let currentLocation =  document.location.href.substring( 0 ,document.location.href.lastIndexOf( "?" ) ).split("/");
                if(currentLocation[currentLocation.length-1]=="recherche-piece"){
                    $('.part_reference_box').find('input').focus();
                }else $('.part_name_box').find('input').focus();
                // var currentLocation =  document.location.href.substring( 0 ,document.location.href.lastIndexOf( "?" ) ).split("/");
                // if(currentLocation[currentLocation.length-1]=="recherche-piece") document.location.href="index.php";
            }).catch(function (error) {
                dispatch(addBoxError('licencePlate', 'Nous n\'avons pas trouvé de véhicule pour cette plaque d\'immatriculation.'));
            }).finally(() => dispatch(toggleBoxLoading('licencePlate')));
    }
}

export function setVehicle(vehicle) {
    return function (dispatch, getState) {
        dispatch({type: GET_VEHICLE, payload: vehicle});
        sendVehicleCookie(vehicle).then(function (response) {
            const state = getState();
            if (state.category.id) {
                dispatch({type: REDIRECT, payload: {url: generateProductsListUrlsFromState(state)}})
            }
        });
    }
}

export function resetVehicle() {
    return function (dispatch) {
        dispatch({type: RESET_VEHICLE});
    }
}

export function emptyVehicle() {
    return function (dispatch) {
        dispatch({type: EMPTY_VEHICLE});
        eraseVehicleCookie();
    }
}

export function selectCategory(category) {
    return function (dispatch, getState) {
        dispatch({type: GET_CATEGORY, payload: category});
        const state = getState();
        if (state.vehicle.type.id) {
            dispatch({type: REDIRECT, payload: {url: generateProductsListUrlsFromState(state)}})
        }
    }
}

export function emptyCategory() {
    return function (dispatch) {
        dispatch({type: EMPTY_CATEGORY})
    }
}

export function toggleBoxLoading(boxName) {
    return function (dispatch) {
        dispatch({type: TOGGLE_BOX_LOADING, payload: {boxName}})
    }
}

export function addBoxError(boxName, errorMessage) {
    return function (dispatch) {
        dispatch({type: ADD_BOX_ERROR, payload: {boxName, errorMessage}})
    }
}

function generateProductsListUrlsFromState(state) {
    let url = "/products";
    const categoryPart = state.category.id + '-' + state.category.slug;
    const brandPart = state.vehicle.brand.id + '-' + state.vehicle.brand.slug;
    const modelGroupPart = state.vehicle.modelGroup.id + '-' + state.vehicle.modelGroup.slug;
    const modelPart = state.vehicle.model.id + '-' + state.vehicle.model.slug;
    const typePart = state.vehicle.type.id + '-' + state.vehicle.type.slug;

    url += '/' + categoryPart + '/' + brandPart + '/' + modelGroupPart + '/' + modelPart + '/' + typePart;

    return url;
}

function sendVehicleCookie(vehicle) {
    let str = "<strong> "+vehicle.brand.name+" </strong>";
    if(vehicle.model.end_date)
    str += vehicle.model.name+" "+vehicle.type.name+" ("+vehicle.model.start_date+" - "+vehicle.model.end_date+")";
    else str += vehicle.model.name+" "+vehicle.type.name+" ("+vehicle.model.start_date+")";
    $('#spanMonVehicule').html(str);
    return axios('/partauto/api/vehicle/cookie?vehicle=' + encodeURIComponent(JSON.stringify(vehicle)));
}

function eraseVehicleCookie() {
    $('#spanMonVehicule').html('Aucun véhicule sélectionné');
    axios('/partauto/api/vehicle/cookie?vehicle=');
}